import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=4c60aeed&"
import script from "./segment.vue?vue&type=script&lang=js&"
export * from "./segment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c60aeed')) {
      api.createRecord('4c60aeed', component.options)
    } else {
      api.reload('4c60aeed', component.options)
    }
    module.hot.accept("./segment.vue?vue&type=template&id=4c60aeed&", function () {
      api.rerender('4c60aeed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/segment.vue"
export default component.exports